import * as React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { Link, DocumentTitle, PageHeader, Spinner } from "components/common";
import { Col, Row, ButtonToolbar } from "components/bootstrap";
import DocsHelper from "util/DocsHelper";
import Routes from "routing/Routes";
import { NodesActions, NodesStore } from "stores/nodes/NodesStore";
import ImportLicenseModal from "license/ImportLicenseModal";
import { useStore } from "stores/connect";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import LicenseList from "license/LicenseList/LicenseList";
import useLicenseMutation from "license/hooks/useLicenseMutation";
import ActiveLicenseInformation from "license/ActiveLicenseInformation";
import { LICENSE_SUBJECTS } from "license/constants";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import LicenseTrafficEventDefinitionModal from "license/traffic/LicenseTrafficEventDefinitionModal";
const LicenseSectionHeading = styled.h2(
  ({ theme }) => `
  margin-bottom: ${theme.spacings.md};
`
);
const LicensesPage = () => {
  const [errorMessage, setErrorMessage] = useState(void 0);
  const [verifiedLicense, setVerifiedLicense] = useState(void 0);
  const sendTelemetry = useSendTelemetry();
  const { saveLicense, verifyLicense } = useLicenseMutation();
  const {
    data: { valid: isValidLicense }
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.enterprise);
  const { nodes } = useStore(NodesStore);
  useEffect(() => {
    NodesActions.list();
  }, []);
  const onVerifyLicense = (token) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.LICENSE.VALIDATED, {
      app_pathname: "license",
      app_section: "license"
    });
    verifyLicense(token).then(({ license, error_message }) => {
      setErrorMessage(error_message);
      setVerifiedLicense(license);
    });
  };
  const onSaveLicense = (token, callback) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.LICENSE.SAVED, {
      app_pathname: "license",
      app_section: "license"
    });
    saveLicense(token).then(() => {
      callback();
      window.location.reload();
    });
  };
  const clusterIdFromFirstNode = () => {
    if (nodes) {
      return Object.keys(nodes).map((id) => nodes[id]).map((node) => node.cluster_id)[0].toUpperCase();
    }
    return void 0;
  };
  const clusterId = clusterIdFromFirstNode();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Graylog license management" }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "Graylog License Management",
      actions: /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(LicenseTrafficEventDefinitionModal, null), /* @__PURE__ */ React.createElement(
        ImportLicenseModal,
        {
          key: "new-license",
          saveLicense: onSaveLicense,
          verifyLicense: onVerifyLicense,
          errorMessage,
          verifiedLicense
        }
      )),
      documentationLink: {
        title: "License documentation",
        path: DocsHelper.PAGES.LICENSE
      }
    },
    /* @__PURE__ */ React.createElement("span", null, "Manage your Graylog Enterprise licenses.", !isValidLicense && /* @__PURE__ */ React.createElement(React.Fragment, null, "\xA0You can get a new license from the\xA0", /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.ENTERPRISE }, "Enterprise page"), "."))
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(LicenseSectionHeading, null, "Active license"), /* @__PURE__ */ React.createElement(ActiveLicenseInformation, null))), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(LicenseSectionHeading, null, "Installed licenses"), clusterId && /* @__PURE__ */ React.createElement("p", null, "This Graylog cluster ID is ", clusterId), nodes ? /* @__PURE__ */ React.createElement(LicenseList, null) : /* @__PURE__ */ React.createElement(Spinner, null)))));
};
export default LicensesPage;
